var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01158512-AE0E-4361-82F7-AB465AAFEDBF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coach-Mvp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Messages-&-Notification-Copy",
    transform: "translate(-1674.000000, -337.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1656.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,261 C21.5733333,261 18,264.573333 18,269 C18,273.426667 21.5733333,277 26,277 C30.4266667,277 34,273.426667 34,269 C34,264.573333 30.4266667,261 26,261 Z M26,273 C25.5555556,273 25.2,272.644444 25.2,272.2 C25.2,271.755556 25.5555556,271.4 26,271.4 L26,271.4 C26.4444444,271.4 26.8,271.755556 26.8,272.2 C26.8,272.644444 26.4444444,273 26,273 Z M28.0027586,267.848235 C27.9034483,267.996979 27.7875862,268.145723 27.6717241,268.275874 C27.5889655,268.368839 27.4896552,268.461804 27.3737931,268.610548 C27.2413793,268.740699 27.142069,268.852257 27.0593103,268.963815 C26.9765517,269.05678 26.8937931,269.149745 26.8441379,269.224117 C26.6951724,269.447233 26.6289655,269.744722 26.6455172,270.023617 L26.6455172,270.6 L25.3544828,270.6 L25.3544828,269.819094 C25.337931,269.558791 25.3710345,269.298489 25.4703448,269.038187 C25.6027586,268.796478 25.7517241,268.573362 25.9503448,268.368839 L26.777931,267.439188 C26.96,267.216072 27.0427586,266.937177 27.0427586,266.639689 C27.0427586,266.342201 26.9434483,266.063306 26.7613793,265.858783 C26.5793103,265.65426 26.3144828,265.542701 26.0496552,265.542701 C25.7848276,265.524108 25.52,265.635667 25.3213793,265.84019 C25.1227586,266.044713 25.0068966,266.342201 24.9903448,266.639689 L23.6,266.639689 C23.6496552,265.951748 23.9310345,265.300992 24.3944828,264.85476 C24.8744828,264.408528 25.4703448,264.185412 26.0993103,264.204005 C26.6951724,264.166819 27.2910345,264.389935 27.7544828,264.817574 C28.1848276,265.22662 28.4,265.821597 28.4,266.565317 C28.3834483,267.030142 28.2510345,267.494967 28.0027586,267.848235 Z",
    id: "icn_search"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/helpCenter.8b44fb8fe763e8b336111d9a820be937.svg";
export { ForwardRef as ReactComponent };